module.exports = __webpack_public_path__ + "assets/arrow_left_carousel-9ff1e3.svg";